import { render, staticRenderFns } from "./NarrativeSource.vue?vue&type=template&id=0ac2002e&scoped=true&"
import script from "./NarrativeSource.vue?vue&type=script&lang=js&"
export * from "./NarrativeSource.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeSource.vue?vue&type=style&index=0&id=0ac2002e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac2002e",
  null
  
)

export default component.exports